import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { SnapshotTextCard } from '../../components/Snapshots/SnapshotCard'

export const UptimeCard: FC = () => {
  const { t } = useTranslation()

  return (
    <SnapshotTextCard title={t('validator.uptime')}>
      {/* TODO: provide uptime stats when API is ready */}-
    </SnapshotTextCard>
  )
}
